const PerformanceManagement = [
  {
    path: "/PerformanceManagement",
    name: "个人绩效",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/PerformanceManagement.vue"
      ),
    meta: { id: 79, hidden: false, name: "menu.PersonalPerformance", keepAlive: true, back: false }
  },
  {
    path: "/PerformanceManagement2",
    name: "小时自动统计推送",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/PerformanceManagement2.vue"
      ),
    meta: { id: 792, hidden: false, name: "menu.PersonalPerformance2", keepAlive: true, back: false }
  },
  {
    path: "/Project",
    name: "项目绩效",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/Project.vue"
      ),
    meta: { id: 79, hidden: false, name: "menu.Project", keepAlive: true, back: false }
  },
  {
    path: "/PerformanceManagement/repayPrincipal",
    name: "回款总金额",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/RepayPrincipal.vue"
      ),
    meta: { id: 549, hidden: true, name: "performance.totalRepayAmount" }
  },
  {
    path: "/PerformanceManagement/loadLeftUnpaidPrincipal",
    name: "分案本金",
    component: () => import( "../views/PerformanceManagement/LoadLeftUnpaidPrincipal.vue"),
    meta: { name: "performance.totalLeftUnpaidPrincipal" }
  },
  {
    path: "/PerformanceComparison",
    name: "绩效对比",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/PerformanceComparison.vue"
      ),
    meta: { id: 82, hidden: false, name: "menu.PerformanceComparison" }
  },
  {
    path: "/Performance/dashboard",
    name: "Dashboard",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/dashboard.vue"
      ),
    meta: { id: 85, hidden: true, name: "menu.Dashboard" }
  },
  {
    path: "/Performance/dashboardScreen",
    name: "DashboardScreen",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/dashboardScreen.vue"
      ),
    meta: { id: 290, hidden: true, name: "menu.DashboardScreen" }
  },
  {
    path: "/Performance/attendanceReport",
    name: "出勤报表",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/AttendanceReport.vue"
      ),
    meta: { id: 203, hidden: true, name: "Attendance Report" }
  },
  {
    path: "/Performance/personalReminderData",
    name: "个人催记数据",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/personalReminderData.vue"
      ),
    meta: { id: 206, hidden: true, name: "Personal collect ticket data" }
    //  209 追踪
  },
  {
    path: "/Performance/personalTrackingData",

    name: "个人追踪数据",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/personalTrackingData.vue"
      ),
    meta: { id: 209, hidden: true, name: "Personal tracking data" }
  },
  {
    path: "/Performance/personalAttendance",
    name: "个人考勤报表",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/personalAttendance.vue"
      ),
    meta: { id: 216, hidden: true, name: "Personal attendance" }
    //  209 追踪
  },
  {
    path: "/Performance/CallRecordQuery",
    name: "通话记录",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/CallRecordQuery.vue"
      ),
    meta: { id: 214, hidden: true, name: "menu.callRecords" }
    //  209 追踪
  },
  {
    path: "/Performance/SalaryReport",
    name: "基本工资查询",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/salaryReport.vue"
      ),
    meta: { id: 219, hidden: true, name: "menu.salaryReport" }
    //  209 追踪
  },
  {
    path: "/Performance/outboundDataStatisticsReport",
    name: "外呼数据统计报表",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/outboundDataStatisticsReport.vue"
      ),
    meta: { id: 234, hidden: true, name: "menuLgy.CallRecordData" }
    //  209 追踪
  },
  {
    path: "/PerformanceManagement/collectionPerformanceDetails",
    name: "催收绩效明细",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/collectionPerformanceDetails.vue"
      ),
    meta: { id: 7901, hidden: true, name: "menuLgy.CollectionPerformanceDetails"}
    //  209 追踪
  },
  {
    path: "/PerformanceManagement/RememberStatistics",
    name: "催记统计报表",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/RememberStatistics.vue"
      ),
    meta: { id: 482, hidden: true, name: "menuLgy.RememberStatistics", keepAlive: false, back: true}
    //  209 追踪
  },
  {
    path: "/PerformanceManagement/ResultStatistics",
    name: "催记结果统计报表",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/ResultStatistics.vue"
      ),
    meta: { id: 529, hidden: true, name: "menuLgy.ResultStatistics", keepAlive: false, back: true}
    //  209 追踪
  },
  {
    path: "/PerformanceManagement/OverdueReasonStat",
    name: "逾期原因统计报表",
    component: () =>
        import(
            /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/OverdueReasonStat.vue"
            ),
    meta: { id: 594, hidden: true, name: "menuLgy.OverdueReasonStat", keepAlive: false, back: true}
  },
  {
    path: "/PerformanceManagement/RememberStatisticsDashboard",
    name: "催记统计报表Dashboard",
    component: () =>
      import(
        /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/RememberStatisticsDashboard.vue"
      ),
    meta: { hidden: true, name: "menuLgy.RememberStatistics" }
    //  209 追踪
  },
  {
    path: "/Performance/smsStats",
    name: "系统内短信用量统计",
    component: () =>
        import(
            /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/smsStats.vue"
            ),
    meta: { id: 523, hidden: true, name: "dashbordDy.smsStats" }
    //  209 追踪
  },
];
export default PerformanceManagement;
